var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ./~/canvg/~/core-js/internals/classof-raw.js
// module id = 75
// module chunks = 0